import { render, staticRenderFns } from "./FanaticsCatalog.vue?vue&type=template&id=30cd5d50"
import script from "./FanaticsCatalog.vue?vue&type=script&lang=js"
export * from "./FanaticsCatalog.vue?vue&type=script&lang=js"
import style0 from "./FanaticsCatalog.vue?vue&type=style&index=0&id=30cd5d50&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports